<template>
  <v-col
    :cols="block.cols"
    :xs="block.colsxs"
    :sm="block.colssm"
    :md="block.colsmd"
    :lg="block.colslg"
    :xl="block.colsxl"
    :offset="block.offset"
    :class="block.class"
  >
    <v-checkbox
      v-model="form"
      :label="block.label"
      outlined
      dense
      hide-details="auto"
    />
  </v-col>
</template>

<script>
export default {
   name: 'Checkbox',
   model: {
      prop: 'form',
      event: 'update:form',
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Object,
         required: true,
      },
   },

   data () {
      return {
         show: false,
      }
   },

   watch: {
      form: {
         deep: true,
         handler (val, oldVal) {
            this.$emit('update:form', this.form)
         },
      },
   },
}
</script>
